import request from "@/router/axios";

/**
 * 条件分页查询
 * @param data
 */
export function analysisStatisticOrderlist(data) {
    return request({
        url: `/analysis/statistic/orderList`,
        method: "post",
        data
    });
}

/**
 * 核心数据-详情页
 * @param data
 */
export function analysisStatisticOrderbasedetail(data) {
    return request({
        url: `/analysis/statistic/orderBaseDetail`,
        method: "post",
        data
    });
}

/**
 * 用餐方式-详情页
 * @param data
 */
export function analysisStatisticEattypedetail(data) {
    return request({
        url: `/analysis/statistic/eatTypeDetail`,
        method: "post",
        data
    });
}

/**
 * 用餐时段-详情页
 * @param data
 */
export function analysisStatisticTimetypedetail(data) {
    return request({
        url: `/analysis/statistic/timeTypeDetail`,
        method: "post",
        data
    });
}